import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 12 14.485"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #7D818A)",
      d: "m6 12.6 3.3-3.3a4.666 4.666 0 1 0-6.6 0zm0 1.885-4.243-4.242a6 6 0 1 1 8.486 0zm0-7.152a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666m0 1.334a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334"
    }, null, -1)
  ]))]))
}
export default { render: render }